import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Checkbox } from '@material-ui/core';
import PropTypes from "prop-types";


class RuleOptionsMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      rulesApplied: this.props.rulesApplied,
      skippedColumnsHidden: this.props.skippedColumnsHidden
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleUpdateRulesApplied = this.handleUpdateRulesApplied.bind(this);
    this.handleUpdateSkippedColumnsHidden = this.handleUpdateSkippedColumnsHidden.bind(this);
    this.handleSortSkippedLinesToBottom = this.handleSortSkippedLinesToBottom.bind(this);
  }

  handleClick (event){
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose() {
    this.setState({ anchorEl: null });
  };

  handleUpdateRulesApplied(event, checked) {
    if(!this.props.saving){
    this.setState({rulesApplied: checked});
    this.props.updateFileRulesApplied(checked);
    }
  }

  handleUpdateSkippedColumnsHidden(event, checked) {
    if(!this.props.saving){
    this.setState({skippedColumnsHidden: checked});
    this.props.updateFileSkippedColumnsHidden(checked);
    }
  }

  handleSortSkippedLinesToBottom(){
    this.props.sortSkippedLinesToBottom();
  }
  render() {

    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <React.Fragment>
        <IconButton
          aria-label="More"
          aria-owns={open ? 'long-menu' : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id='long-menu'
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}

        >
          <MenuItem ><label htmlFor="rulesActiveCheckbox">Rules Enabled </label><Checkbox id="rulesActiveCheckbox" disabled={this.props.saving} checked={this.props.rulesApplied} onChange={this.handleUpdateRulesApplied} style={{marginLeft:'auto'}} ></Checkbox></MenuItem>
          <MenuItem><label htmlFor="rulesHideSkippedColumns">Hide Skipped Rows</label><Checkbox id="rulesHideSkippedColumns" disabled={this.props.saving} checked={this.props.skippedColumnsHidden} onChange={this.handleUpdateSkippedColumnsHidden} style={{marginLeft:'auto'}}></Checkbox></MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}

RuleOptionsMenu.propTypes = {
  rulesApplied: PropTypes.bool,
  skippedColumnsHidden: PropTypes.bool,
  updateFileSkippedColumnsHidden: PropTypes.func,
  updateFileRulesApplied: PropTypes.func,
  saving: PropTypes.bool,
  sortSkippedLinesToBottom: PropTypes.func
};
export default RuleOptionsMenu;
